// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".App_app__1kX79 {\n  font-family: 'Roboto Mono', monospace;\n  min-width: 600px;\n}\n", "",{"version":3,"sources":["webpack://src/App.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,gBAAgB;AAClB","sourcesContent":[".app {\n  font-family: 'Roboto Mono', monospace;\n  min-width: 600px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": "App_app__1kX79"
};
export default ___CSS_LOADER_EXPORT___;
